module.exports = __webpack_public_path__ + "assets/aa845b9129a4c8fee6860c167b7b8b52.png";